// This must be the first line in src/index.js
import "react-app-polyfill/stable";
import "url-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Section from "./Section";
import svg4everybody from "svg4everybody";
import { PageData } from "./serverData";

svg4everybody();

// some checks and validations during development
if (process.env.NODE_ENV === "development") {
  let devChecks = require("./devChecks");
  devChecks.clientRedirect();
  devChecks.uniqueColorVariables();
}

// pages
const root = document.getElementById("root");
const autoRun = PageData.autoRun;

function render() {
  if (root) ReactDOM.render(<App />, root);
}

if (autoRun === false) {
  if (window.onReactReady) window.onReactReady(render);
} else render();

// sections (react parts in legacy pages)
const sections = Array.prototype.slice.call(
  document.querySelectorAll(".section-root")
);

function renderReactComponent(el) {
  ReactDOM.render(
    <Section
      name={el.getAttribute("data-section-name")}
      id={el.getAttribute("data-section-id")}
      service={el.getAttribute("data-section-service")}
      dataProps={el.getAttribute("data-section-props")}
    />,
    el
  );
}

sections.forEach(renderReactComponent);

window.renderReactComponent = renderReactComponent;
